export default {
  title: 'รายงาน',
  description: 'ดูรายงานอัตราการเข้าพักและรายรับ',
  select_property: 'เลือกอสังหาริมทรัพย์',

  breadcrumbs: {
    details: 'รายละเอียด', // [TH-review]
  },

  occupancy: {
    title: 'รายงานอัตราการเข้าพัก',
    total_units: 'ห้องทั้งหมด',
    occupied_units: 'มีผู้เช่า',
    vacant_units: 'ว่าง',
    occupancy_rate: 'อัตราการเข้าพัก',
    trend: 'แนวโน้มอัตราการเข้าพัก',
    breakdown: 'รายละเอียดตามอสังหาริมทรัพย์',
  },

  revenue: {
    title: 'รายงานรายรับ',
    total_invoiced: 'ยอดเรียกเก็บ',
    total_collected: 'ยอดรับชำระ',
    outstanding: 'ยอดค้างชำระ',
    collection_rate: 'อัตราการเก็บเงิน',
    chart_title: 'รายรับตามเวลา',
    breakdown: 'รายละเอียดตามอสังหาริมทรัพย์',
  },

  filters: {
    property: 'อสังหาริมทรัพย์',
    all_properties: 'ทุกอาคาร',
    date_range: 'ช่วงวันที่',
    from: 'จาก',
    to: 'ถึง',
    period: 'ช่วงเวลา',
    daily: 'รายวัน',
    monthly: 'รายเดือน',
    yearly: 'รายปี',
    quarterly: 'รายไตรมาส',
    // RPT-3 additions
    toggle: 'ตัวกรอง', // [TH-review]
    all_periods: 'ทุกช่วงเวลา', // [TH-review]
    date_preset: 'ช่วงวันที่',
    preset_current_cycle: 'รอบบิลปัจจุบัน',
    preset_full_year: 'ทั้งปี',
    preset_last3m: '3 เดือนที่ผ่านมา', // [TH-review]
    preset_last6m: '6 เดือนที่ผ่านมา', // [TH-review]
    preset_last12m: '12 เดือนที่ผ่านมา', // [TH-review]
    preset_ytd: 'ปีปัจจุบัน', // [TH-review]
    preset_custom: 'กำหนดเอง', // [TH-review]
  },

  labels: {
    invoiced: 'เรียกเก็บ',
    collected: 'รับชำระ',
    property_name: 'อสังหาริมทรัพย์',
    total: 'รวม',
    occupied: 'มีผู้เช่า',
    rate: 'อัตรา',
    refreshing: 'กำลังโหลด…',
  },

  empty: {
    title: 'ไม่มีข้อมูล',
    description: 'ข้อมูลรายงานจะปรากฏเมื่อคุณมีอสังหาริมทรัพย์และใบแจ้งหนี้',
  },

  setup_guide: {
    occupancy: {
      title: 'ตั้งค่ารายงานอัตราการเข้าพัก',
      description: 'คุณต้องมีอสังหาริมทรัพย์ที่มีห้องและสัญญาเช่าเพื่อดูข้อมูลอัตราการเข้าพัก',
    },
    revenue: {
      title: 'ตั้งค่ารายงานรายรับ',
      description: 'คุณต้องสร้างใบแจ้งหนี้เพื่อดูข้อมูลรายรับ',
    },
  },

  actions: {
    print: 'พิมพ์',
    export_csv: 'ส่งออก CSV',
  },

  // RPT-9 5a — Parking Occupancy (locked design 2026-05-28)
  parking_occupancy: {
    title: 'การใช้พื้นที่จอดรถ', // [TH-review]
    subtitle: 'ภาพรวมการใช้พื้นที่ตามโซน', // [TH-review]
    export_csv: 'ส่งออก CSV',
    filters_label: 'ตัวกรอง',
    filter_property: 'อาคาร',
    filter_zone: 'โซน',
    all_zones: 'ทุกโซน', // [TH-review]
    kpi_spaces: 'พื้นที่จอดทั้งหมด', // [TH-review]
    kpi_occupied: 'ใช้งาน', // [TH-review]
    kpi_vacant: 'ว่าง', // [TH-review]
    kpi_rate: 'อัตราการใช้งาน', // [TH-review]
    chart_section_title: 'อัตราการใช้งานตามโซน', // [TH-review]
    table_section_title: 'รายละเอียดตามโซน', // [TH-review]
    col_zone: 'โซน',
    col_spaces: 'พื้นที่จอด', // [TH-review]
    col_occupied: 'ใช้งาน', // [TH-review]
    col_vacant: 'ว่าง', // [TH-review]
    col_rate: 'อัตรา', // [TH-review]
    covered_badge: 'มีหลังคา', // [TH-review]
    no_zones: 'ไม่มีโซนจอดรถ', // [TH-review]
  },

  // RPT-9 5b — Parking Revenue (locked design 2026-05-28)
  parking_revenue: {
    title: 'รายรับที่จอดรถ', // [TH-review]
    subtitle: 'รายรับตามแหล่งที่มาตามช่วงเวลา', // [TH-review]
    export_csv: 'ส่งออก CSV',
    filters_label: 'ตัวกรอง',
    filter_property: 'อาคาร',
    filter_stream: 'แหล่งรายรับ', // [TH-review]
    kpi_total: 'รายรับที่จอดรถรวม', // [TH-review]
    kpi_tenant: 'ผู้เช่า (เสริม)', // [TH-review]
    kpi_external: 'ภายนอก', // [TH-review]
    kpi_outstanding: 'ค้างชำระ', // [TH-review]
    chart_section_title: 'รายรับที่จอดรถต่อเดือน', // [TH-review]
    legend_tenant: 'ผู้เช่า (เสริม)', // [TH-review]
    legend_external: 'ภายนอก', // [TH-review]
    table_section_title: 'ตามแหล่งรายรับ', // [TH-review]
    col_stream: 'แหล่งรายรับ', // [TH-review]
    col_vehicles: 'ยานพาหนะ', // [TH-review]
    col_revenue: 'รายรับ', // [TH-review]
    col_outstanding: 'ค้างชำระ', // [TH-review]
    stream_tenant: 'ผู้เช่า (เสริม)', // [TH-review]
    stream_external: 'ภายนอก', // [TH-review]
    no_revenue: 'ไม่มีรายรับที่จอดรถในช่วงนี้', // [TH-review]
  },

  // RPT-9 5c — Parking Registry (locked design 2026-05-28)
  parking_registry: {
    title: 'ทะเบียนที่จอดรถ', // [TH-review]
    subtitle: 'ต่ออายุใบอนุญาต ติดตามการลงทะเบียน', // [TH-review]
    export_csv: 'ส่งออก CSV',
    filters_label: 'ตัวกรอง',
    filter_property: 'อาคาร',
    filter_expiring_within: 'หมดอายุภายใน', // [TH-review]
    window_30: '30 วัน',
    window_60: '60 วัน',
    window_90: '90 วัน',
    kpi_registered: 'ยานพาหนะที่จดทะเบียน', // [TH-review]
    kpi_unregistered: 'ห้องที่ยังไม่จดทะเบียน', // [TH-review]
    kpi_expiring: 'หมดอายุใน 30 วัน', // [TH-review]
    unregistered_section_title: 'ห้องที่ยังไม่จดทะเบียน', // [TH-review]
    unregistered_section_subtitle: 'ผู้เช่าที่มีสัญญาเช่าแต่ยังไม่มียานพาหนะจดทะเบียน', // [TH-review]
    expiring_section_title: 'ใบอนุญาตที่กำลังจะหมดอายุ / หมดอายุแล้ว', // [TH-review]
    expiring_section_subtitle: 'ใบอนุญาตที่จะหมดอายุภายในช่วงที่เลือก', // [TH-review]
    col_unit: 'ห้อง',
    col_property: 'อาคาร',
    col_tenant: 'ผู้เช่า', // [TH-review]
    col_lease_since: 'เช่าตั้งแต่', // [TH-review]
    col_plate: 'ทะเบียน', // [TH-review]
    col_unit_property: 'ห้อง / อาคาร', // [TH-review]
    col_expires: 'หมดอายุ', // [TH-review]
    col_days_left: 'เหลือ (วัน)', // [TH-review]
    days_left_one: 'เหลือ {{count}} วัน', // [TH-review]
    days_left_other: 'เหลือ {{count}} วัน', // [TH-review]
    expired_badge: 'หมดอายุแล้ว', // [TH-review]
    no_unregistered_units: 'ไม่มีห้องที่ยังไม่ได้จดทะเบียน', // [TH-review]
    no_expiring_permits: 'ไม่มีใบอนุญาตที่กำลังจะหมดอายุ', // [TH-review]
  },

  expense_section_title: 'รายงานค่าใช้จ่ายและการเงิน',

  expense_summary: {
    title: 'สรุปค่าใช้จ่าย',
    description: 'ภาพรวมค่าใช้จ่ายตามหมวดหมู่และอสังหาริมทรัพย์',
    total_expenses: 'ค่าใช้จ่ายรวม',
    by_category: 'ตามหมวดหมู่',
    by_property: 'ตามอสังหาริมทรัพย์',
    percentage: '% ของทั้งหมด',
  },

  expense_trend: {
    title: 'แนวโน้มค่าใช้จ่าย',
    description: 'แนวโน้มค่าใช้จ่ายรายเดือนตามหมวดหมู่',
  },

  profit_loss: {
    basis_label: 'เกณฑ์รายได้',
    basis_billed: 'ตามใบแจ้งหนี้',
    basis_received: 'ตามเงินที่ได้รับ',
    expense_including_vat: 'ค่าใช้จ่ายรวม VAT',
    expense_excluding_vat: 'ค่าใช้จ่ายไม่รวม VAT',
    net_basis: '{{income}} − {{expense}}',
    grouping_hint: 'เลือกเส้นแนวโน้ม ยอดรวมยังคงตามอาคารที่เลือกในรายงาน',
    expense_categories_scope: 'หมวดค่าใช้จ่ายตามขอบเขตรายงานนี้',
    title: 'กำไร-ขาดทุน',
    description: 'การวิเคราะห์รายรับเทียบกับค่าใช้จ่าย',
    // Legacy keys (backward compat)
    revenue: 'รายรับ',
    revenue_collected: 'รายรับ (เงินที่รับมา)',
    expenses: 'ค่าใช้จ่าย',
    net_profit: 'กำไรสุทธิ',
    margin: 'อัตรากำไร %',
    // RPT-7 Glance + Details keys [TH-review]
    subtitle: 'รายได้หักค่าใช้จ่าย ผลกำไรสุทธิ', // [TH-review]
    default_scope_hint: 'งวดนี้ · ทุกอาคาร', // [TH-review]
    scope_hint_property: 'งวดนี้ · {{property}}', // [TH-review]
    details_cta: 'แยกตามอาคารและตัวกรอง', // [TH-review]
    kpi_income: 'รายได้', // [TH-review]
    kpi_expense: 'ค่าใช้จ่าย', // [TH-review]
    kpi_net: 'กำไรสุทธิ', // [TH-review]
    kpi_margin: 'อัตรากำไร', // [TH-review]
    trend_section_title: 'แนวโน้มกำไรสุทธิ (6 เดือน)', // [TH-review]
    trend_title: 'แนวโน้มกำไรสุทธิ', // [TH-review]
    target_line_label: 'เป้าหมาย', // [TH-review]
    grouping_label: 'การจัดกลุ่ม', // [TH-review]
    grouping_all: 'ทุกอาคาร', // [TH-review]
    granularity_label: 'ความละเอียด', // [TH-review]
    daily: 'รายวัน', // [TH-review]
    monthly: 'รายเดือน', // [TH-review]
    yearly: 'รายปี', // [TH-review]
    filter_unit: 'ห้อง', // [TH-review]
    hero_swap_label: 'ประเภทกราฟ', // [TH-review]
    swap_line: 'เส้น', // [TH-review]
    swap_waterfall: 'น้ำตก', // [TH-review]
    swap_treemap: 'Treemap', // [TH-review]
    breakdown_section_title: 'แยกรายอาคาร', // [TH-review]
    col_income: 'รายได้', // [TH-review]
    col_expense: 'ค่าใช้จ่าย', // [TH-review]
    col_net: 'กำไรสุทธิ', // [TH-review]
    col_margin: 'อัตรากำไร', // [TH-review]
    income_categories: 'หมวดรายได้', // [TH-review]
    expense_categories: 'หมวดค่าใช้จ่าย', // [TH-review]
    expense_categories_portfolio: 'หมวดค่าใช้จ่าย (รวมทุกอาคาร)', // [TH-review]
    treemap_leaf_label: 'หมวดค่าใช้จ่าย', // [TH-review]
  },

  collection_rate: {
    title: 'อัตราการเก็บเงิน',
    description: 'แนวโน้มอัตราการเก็บเงินตามใบแจ้งหนี้รายเดือน',
    invoiced: 'เรียกเก็บ',
    collected: 'รับชำระ',
    rate: 'อัตรา',
  },

  empty_state: {
    no_data: {
      title: 'ไม่มีข้อมูล',
      description: 'ปรับตัวกรองเพื่อดูผลลัพธ์', // [TH-review]
      action: 'ปรับตัวกรอง', // [TH-review]
    },
    no_properties: {
      title: 'ยังไม่มีอสังหาริมทรัพย์',
      description: 'เพิ่มอสังหาริมทรัพย์เพื่อเริ่มดูรายงาน', // [TH-review]
      action: 'ไปที่อสังหาริมทรัพย์', // [TH-review]
    },
    error: {
      title: 'โหลดข้อมูลไม่สำเร็จ',
      description: 'เกิดข้อผิดพลาดขณะโหลดรายงานนี้', // [TH-review]
      action: 'ลองอีกครั้ง',
    },
  },

  week_lock: {
    header: 'สัปดาห์ล็อค {{locked}}/{{total}}', // [TH-review]
  },

  // Reports index hub (RPT-4)
  index: {
    rent_roll: 'ค่าเช่ารวมต่อเดือน',
    // 2026-09-29: the tile carries no description line any more, so the label
    // says what the figure is (rent the vacant units would bring each month).
    vacancy_gap: 'ค่าเช่าที่ขาดจากห้องว่าง',
    // Quick-summary strip tile labels (reused by BusinessSnapshot on dashboard)
    qs_billed: 'ยอดออกบิล',
    qs_unpaid: 'ยังไม่ชำระ',
    qs_overdue: 'เกินกำหนด',
    nothing_billed: 'ยังไม่ได้ออกใบแจ้งหนี้งวดนี้',
    generate_invoices: 'ออกใบแจ้งหนี้',
    qs_revenue: 'ยอดรับแล้ว', // [TH-review]
    qs_collection_rate: 'อัตราการเก็บเงิน', // [TH-review]
    qs_occupancy: 'อัตราการเข้าพัก', // [TH-review]
    qs_net_profit: 'กำไรสุทธิ', // [TH-review]
    // EP-149 T149-081 (MON-7 D): account-wide balance, not period-scoped like
    // the tiles above. Label is the owner's exact wording (2026-09-23 ruling).
    qs_deposits_held: 'เงินประกันที่ถืออยู่',

    // Group card titles
    group_collections: 'การเก็บเงิน', // [TH-review]
    group_occupancy: 'การเข้าพัก', // [TH-review]
    group_profitability: 'ผลกำไร', // [TH-review]
    group_records: 'บันทึกการจัดการ', // [TH-review]
    group_parking: 'ที่จอดรถ', // [TH-review]

    // Group card report-preview labels
    preview_collections: 'สถิติการเก็บ · คะแนนผู้เช่า · ค้างชำระ', // [TH-review]
    preview_occupancy: 'สถิติการเข้าพัก · ห้องว่าง', // [TH-review]
    preview_profitability: 'กำไร-ขาดทุน', // [TH-review]
    preview_records: 'ใบบันทึกเวลา · งานซ่อม · CAF · กระทบยอด · งบการเงิน', // [TH-review]
    preview_parking: 'อัตราจอดรถ · รายรับ · ทะเบียน', // [TH-review]

    // Group landing page descriptions
    desc_collections: 'ยอดเรียกเก็บเทียบกับยอดรับ คุณภาพผู้เช่า และการติดตามค้างชำระ', // [TH-review]
    desc_occupancy: 'อัตราการเข้าพัก แนวโน้ม และรายละเอียดห้องว่าง', // [TH-review]
    desc_profitability: 'รายรับลบค่าใช้จ่าย กำไรสุทธิ', // [TH-review]
    desc_records: 'ชั่วโมงพนักงาน ใบสั่งงาน ค่าธรรมเนียมพื้นที่ส่วนกลาง และกระทบยอดธนาคาร', // [TH-review]
    desc_parking: 'การใช้โซน รายรับ และทะเบียนใบอนุญาต', // [TH-review]
  },

  // RPT-5: Collection Stats (1a)
  collection_stats: {
    title: 'สถิติการเก็บเงิน', // [TH-review]
    subtitle: 'ยอดเรียกเก็บเทียบกับยอดรับ สุขภาพการเก็บเงินตามเวลา', // [TH-review]
    kpi_invoiced: 'ยอดเรียกเก็บรวม', // [TH-review]
    kpi_collected: 'ยอดรับชำระรวม', // [TH-review]
    kpi_rate: 'อัตราการเก็บเงิน', // [TH-review]
    kpi_avg_days: 'เฉลี่ยวันเก็บเงิน', // [TH-review]
    rate_healthy_hint: '✓ ≥ 90%',
    trend_section_title: 'แนวโน้มอัตราการเก็บเงิน (6 เดือน)', // [TH-review]
    trend_title: 'แนวโน้มอัตราการเก็บเงิน', // [TH-review]
    breakdown_section_title: 'แยกตามอาคาร', // [TH-review]
    details_cta: 'แยกตามอาคาร & ตัวกรอง', // [TH-review]
    default_scope_hint: 'งวดปัจจุบัน · ทุกอาคาร', // [TH-review]
    grouping_label: 'การจัดกลุ่ม', // [TH-review]
    grouping_all: 'ทุกอาคาร', // [TH-review]
    col_avg_days: 'วันเฉลี่ย', // [TH-review]
  },

  // RPT-5: Tenant Scorecard (1b)
  tenant_scorecard: {
    title: 'คะแนนผู้เช่า', // [TH-review]
    subtitle: 'สัญญาณคุณภาพการต่อสัญญาต่อผู้เช่า', // [TH-review]
    kpi_total_tenants: 'ผู้เช่าทั้งหมด', // [TH-review]
    kpi_avg_score: 'คะแนนเฉลี่ย', // [TH-review]
    kpi_up_renewal: 'ใกล้ต่อสัญญา', // [TH-review]
    kpi_watch: 'เฝ้าระวัง (<50)', // [TH-review]
    quality_by_property_title: 'คุณภาพผู้เช่าตามอาคาร', // [TH-review]
    band_strong: 'ดี', // [TH-review]
    band_ok: 'ปานกลาง', // [TH-review]
    band_watch: 'เฝ้าระวัง', // [TH-review]
    tenant_count: '{{count}} คน', // [TH-review]
    axis_payment: 'การชำระเงิน', // [TH-review]
    axis_maintenance: 'การแจ้งซ่อม', // [TH-review]
    axis_parcel: 'พัสดุ', // [TH-review]
    overall_label: 'ภาพรวม', // [TH-review]
    rail_search_placeholder: 'ค้นหาผู้เช่า…', // [TH-review]
    detail_payment_facts: 'ประวัติการชำระเงิน', // [TH-review]
    detail_maint_facts: 'การแจ้งซ่อม', // [TH-review]
    detail_parcel_facts: 'พัสดุ', // [TH-review]
    lease_term_label: 'ระยะเวลาสัญญา', // [TH-review]
    view_lease_cta: 'ดูสัญญา', // [TH-review]
    default_scope_hint: '12 เดือนที่ผ่านมา · ทุกอาคาร', // [TH-review]
    lookback_label: 'ช่วงเวลาย้อนหลัง', // [TH-review]
    near_expiry_badge: 'ใกล้ต่อสัญญา', // [TH-review]
    fact_total_invoices: 'ใบแจ้งหนี้ทั้งหมด', // [TH-review]
    fact_on_time: 'ตรงเวลา', // [TH-review]
    fact_overdue: 'ค้างชำระ', // [TH-review]
    fact_avg_days_late: 'จำนวนวันล่าช้าเฉลี่ย', // [TH-review]
    fact_total_requests: 'คำร้องทั้งหมด', // [TH-review]
    fact_resolved: 'ดำเนินการเสร็จสิ้น', // [TH-review]
    fact_total_parcels: 'พัสดุทั้งหมด', // [TH-review]
    fact_avg_pickup_days: 'จำนวนวันรับพัสดุเฉลี่ย', // [TH-review]
    lease_start_label: 'วันเริ่มต้น', // [TH-review]
    lease_end_label: 'วันสิ้นสุด', // [TH-review]
  },

  // RPT-5: Overdue Invoices (1c)
  overdue: {
    title: 'ใบแจ้งหนี้ค้างชำระ', // [TH-review]
    subtitle: 'คุณภาพการเก็บหนี้และรายการติดตาม', // [TH-review]
    export_csv: 'ส่งออก CSV', // [TH-review]
    filters_label: 'ตัวกรอง', // [TH-review]
    kpi_total_unpaid: 'ยังไม่ชำระ',
    kpi_total_overdue: 'เกินกำหนด',
    kpi_count: 'จำนวนค้างชำระ', // [TH-review]
    kpi_tenant_on_time: 'ผู้เช่าชำระตรงเวลา %', // [TH-review]
    kpi_admin_recovery: 'ผู้ดูแลเรียกเก็บได้ %', // [TH-review]
    portfolio_hint: 'ภาพรวม', // [TH-review]
    quality_chart_title: 'คุณภาพการเก็บหนี้ตามอาคาร', // [TH-review]
    series_tenant_on_time: 'ผู้เช่าชำระตรงเวลา', // [TH-review]
    series_admin_recovery: 'ผู้ดูแลเรียกเก็บได้', // [TH-review]
    chase_priority_hint: 'อ่อนทั้งสองแกน → ติดตามก่อน', // [TH-review]
    col_invoice: 'ใบแจ้งหนี้', // [TH-review]
    col_tenant: 'ผู้เช่า', // [TH-review]
    col_unit: 'ห้อง', // [TH-review]
    col_property: 'อาคาร', // [TH-review]
    col_amount: 'จำนวน', // [TH-review]
    col_paid: 'ชำระแล้ว', // [TH-review]
    col_balance: 'ยอดคงเหลือ', // [TH-review]
    col_due: 'วันครบกำหนด', // [TH-review]
    col_days_late: 'ล่าช้า', // [TH-review]
    days_late: 'ล่าช้า {{count}} วัน', // [TH-review]
    sort_worst_first: 'แย่สุดก่อน', // [TH-review]
    no_overdue: 'ไม่มีใบแจ้งหนี้ค้างชำระ', // [TH-review]
    row_aria_label: 'ใบแจ้งหนี้ {{number}}', // [TH-review]
    rate_unavailable: 'ไม่มีอัตรา: ยังไม่มีใบแจ้งหนี้ที่เข้าเกณฑ์',
    aging_title: 'อายุหนี้แยกตามอาคาร',
    no_aging: 'ไม่มีใบแจ้งหนี้ในช่วงเวลานี้',
    aging_count: '{{count}} ใบ',
    aging_buckets: {
      not_yet_due: 'ยังไม่ครบกำหนด',
      '1_30': '1–30 วัน',
      '31_60': '31–60 วัน',
      '61_90': '61–90 วัน',
      over_90: 'เกิน 90 วัน',
    },
  },

  // RPT-6: Occupancy Stats (2a)
  occupancy_stats: {
    title: 'สถิติการเข้าพัก', // [TH-review]
    subtitle: 'อัตราการเข้าพักและแนวโน้มตามเวลา', // [TH-review]
    kpi_rate: 'อัตราการเข้าพัก', // [TH-review]
    kpi_occupied: 'ห้องที่มีผู้เช่า', // [TH-review]
    kpi_vacant: 'ห้องว่าง', // [TH-review]
    kpi_total: 'ห้องทั้งหมด', // [TH-review]
    healthy_threshold_hint: '✓ ≥ 85%',
    trend_section_title: 'แนวโน้มอัตราการเข้าพัก (6 เดือน)', // [TH-review]
    trend_title: 'แนวโน้มอัตราการเข้าพัก', // [TH-review]
    breakdown_section_title: 'แยกตามอาคาร', // [TH-review]
    details_cta: 'แยกตามอาคาร & ตัวกรอง', // [TH-review]
    default_scope_hint: '6 เดือนที่ผ่านมา · ทุกอาคาร', // [TH-review]
    grouping_label: 'การจัดกลุ่ม', // [TH-review]
    grouping_all: 'ทุกอาคาร', // [TH-review]
    col_occupied: 'มีผู้เช่า', // [TH-review]
    col_vacant: 'ว่าง', // [TH-review]
    col_rate: 'อัตรา', // [TH-review]
    col_delta: 'Δ vs ก่อนหน้า', // [TH-review]
    granularity_label: 'ความละเอียด', // [TH-review]
    daily: 'รายวัน', // [TH-review]
    monthly: 'รายเดือน', // [TH-review]
    yearly: 'รายปี', // [TH-review]
    // TODO RPT-10 heatmap swap
  },

  // RPT-6: Vacant Units (2b)
  vacant: {
    title: 'ห้องว่าง', // [TH-review]
    subtitle: 'ห้องว่างและค่าเช่าที่สูญเสีย', // [TH-review]
    kpi_vacant_count: 'ห้องว่าง', // [TH-review]
    kpi_vacancy_rate: 'อัตราห้องว่าง', // [TH-review]
    kpi_avg_days: 'เฉลี่ยวันว่าง', // [TH-review]
    kpi_lost_rent: 'ค่าเช่าที่สูญ/เดือน', // [TH-review]
    chart_title: 'ค่าเช่าที่สูญตามอาคาร', // [TH-review]
    list_section_title: 'ห้องว่าง (ว่างนานสุดก่อน)', // [TH-review]
    col_unit: 'ห้อง', // [TH-review]
    col_property: 'อาคาร', // [TH-review]
    col_room_type: 'ประเภทห้อง', // [TH-review]
    col_rent: 'ค่าเช่า', // [TH-review]
    col_vacant_since: 'ว่างตั้งแต่', // [TH-review]
    col_days_vacant: 'วันที่ว่าง', // [TH-review]
    days_badge_error: '>60 วัน', // [TH-review]
    days_badge_warning: '≤60 วัน', // [TH-review]
    no_vacant_units: 'ทุกห้องมีผู้เช่าอยู่', // [TH-review]
    export_csv: 'ส่งออก CSV', // [TH-review]
    filters_label: 'ตัวกรอง', // [TH-review]
    vacant_since_cutoff_label: 'ว่างตั้งแต่ (ตัดยอด)', // [TH-review]
    unit_type_label: 'ประเภทห้อง', // [TH-review]
    all_unit_types: 'ทุกประเภท', // [TH-review]
    default_scope_hint: 'ทุกอาคาร · ทุกช่วงเวลา', // [TH-review]
  },

  // Level-2 group landing pages (RPT-4)
  report_cards: {
    collection_stats: {
      title: 'สถิติการเก็บเงิน', // [TH-review]
      description: 'ยอดเรียกเก็บเทียบกับยอดรับตามเวลา', // [TH-review]
    },
    tenant_scorecard: {
      title: 'คะแนนผู้เช่า', // [TH-review]
      description: 'คะแนนคุณภาพการต่อสัญญาต่อผู้เช่า', // [TH-review]
    },
    overdue_invoices: {
      title: 'ใบแจ้งหนี้ค้างชำระ', // [TH-review]
      description: 'ใครค้างชำระและเป็นจำนวนเท่าไร', // [TH-review]
    },
    occupancy_stats: {
      title: 'สถิติการเข้าพัก', // [TH-review]
      description: 'อัตราการเข้าพักและแนวโน้ม', // [TH-review]
    },
    vacant_units: {
      title: 'ห้องว่าง', // [TH-review]
      description: 'ห้องที่ว่างและจำนวนวันที่ว่าง', // [TH-review]
    },
    profit_loss: {
      title: 'กำไร-ขาดทุน', // [TH-review]
      description: 'รายรับลบค่าใช้จ่าย', // [TH-review]
    },
    timesheets: {
      title: 'ใบบันทึกเวลา', // [TH-review]
      description: 'ชั่วโมงการทำงานของพนักงานต่อรอบ', // [TH-review]
    },
    maintenance: {
      title: 'งานซ่อมบำรุง', // [TH-review]
      description: 'กิจกรรมใบสั่งงานและอัตราความสำเร็จ', // [TH-review]
    },
    caf_collection: {
      title: 'การเก็บค่าธรรมเนียม CAF', // [TH-review]
      description: 'ค่าธรรมเนียมพื้นที่ส่วนกลางเรียกเก็บเทียบกับรับ', // [TH-review]
    },
    bank_reconciliation: {
      title: 'กระทบยอดธนาคาร', // [TH-review]
      description: 'รายการที่จับคู่และไม่ตรง', // [TH-review]
    },
    financial_statements: {
      title: 'งบการเงิน', // [TH-review]
      description: 'งบการเงิน GL สำหรับส่งออกบัญชี', // [TH-review]
    },
    parking_occupancy: {
      title: 'อัตราการจอดรถ', // [TH-review]
      description: 'อัตราการใช้โซนและช่องจอด', // [TH-review]
    },
    parking_revenue: {
      title: 'รายรับจากที่จอดรถ', // [TH-review]
      description: 'รายรับที่จอดรถแยกตามหมวดหมู่', // [TH-review]
    },
    parking_registry: {
      title: 'ทะเบียนที่จอดรถ', // [TH-review]
      description: 'ใบอนุญาตและการลงทะเบียนยานพาหนะ', // [TH-review]
    },
  },

  // ===== RPT-8 — Juristic / Management Records reports (4a-4e) =====
  records: {
    timesheets: {
      title: 'ใบลงเวลา',
      subtitle: 'ชั่วโมงทำงานและสถานะการล็อกรายสัปดาห์', // [TH-review]
      export_csv: 'ส่งออก CSV',
      filters_label: 'ตัวกรอง',
      filter_property: 'อสังหาริมทรัพย์',
      filter_staff: 'พนักงาน',
      kpi_total_hours: 'ชั่วโมงรวม',
      kpi_staff_count: 'จำนวนพนักงาน',
      kpi_avg_hours: 'เฉลี่ยชั่วโมง/คน', // [TH-review]
      kpi_weeks_locked: 'สัปดาห์ที่ล็อกแล้ว', // [TH-review]
      week_lock_strip_title: 'สถานะการล็อกรายสัปดาห์', // [TH-review]
      week_locked: 'ล็อก', // [TH-review]
      week_open: 'ยังไม่ล็อก', // [TH-review]
      chart_section_title: 'ชั่วโมงตามพนักงาน', // [TH-review]
      table_section_title: 'ชั่วโมงพนักงาน', // [TH-review]
      col_staff: 'พนักงาน',
      col_role: 'ตำแหน่ง',
      col_hours: 'ชั่วโมง',
      col_days_worked: 'วันที่ทำงาน',
      no_entries: 'ไม่มีรายการลงเวลาในช่วงนี้', // [TH-review]
    },
    maintenance: {
      title: 'งานซ่อมบำรุง',
      subtitle: 'ปริมาณคำขอแจ้งซ่อมตามสถานะ', // [TH-review]
      export_csv: 'ส่งออก CSV',
      filters_label: 'ตัวกรอง',
      filter_property: 'อสังหาริมทรัพย์',
      filter_status: 'สถานะ',
      kpi_total: 'คำขอทั้งหมด', // [TH-review]
      kpi_fixed: 'ซ่อมแล้ว', // [TH-review]
      kpi_open: 'ค้าง', // [TH-review]
      kpi_closed: 'ปิด', // [TH-review]
      volume_section_title: 'คำขอต่อเดือน', // [TH-review]
      legend_open: 'ค้าง', // [TH-review]
      legend_fixed: 'ซ่อมแล้ว', // [TH-review]
      legend_closed: 'ปิด', // [TH-review]
      table_section_title: 'คำขอแจ้งซ่อม', // [TH-review]
      col_req: 'เลขที่คำขอ', // [TH-review]
      col_property_unit: 'อาคาร / ห้อง', // [TH-review]
      col_category: 'หมวดหมู่',
      col_status: 'สถานะ',
      col_dates: 'เปิด / ปิด', // [TH-review]
      status_open: 'ค้าง', // [TH-review]
      status_fixed: 'ซ่อมแล้ว', // [TH-review]
      status_closed: 'ปิด', // [TH-review]
      filter_status_all: 'ทุกสถานะ', // [TH-review]
      filter_status_open: 'เปิด', // [TH-review]
      filter_status_in_progress: 'กำลังดำเนินการ',
      filter_status_completed: 'เสร็จสิ้น',
      no_requests: 'ไม่มีคำขอแจ้งซ่อมในช่วงนี้', // [TH-review]
    },
    caf: {
      title: 'การเก็บค่าส่วนกลาง',
      subtitle: 'ค่าส่วนกลางที่เรียกเก็บเทียบกับรับชำระ', // [TH-review]
      export_csv: 'ส่งออก CSV',
      filters_label: 'ตัวกรอง',
      filter_property: 'อสังหาริมทรัพย์',
      filter_unit: 'ห้อง',
      view_label: 'มุมมอง', // [TH-review]
      view_money: 'ยอดเงิน', // [TH-review]
      view_records: 'รายการ', // [TH-review]
      kpi_billed: 'ค่าส่วนกลางที่เรียกเก็บ',
      kpi_collected: 'รับชำระแล้ว',
      kpi_rate: 'อัตราการรับชำระ',
      kpi_outstanding: 'ค้างชำระ',
      chart_money_title: 'ค่าส่วนกลางที่เรียกเก็บต่อเดือน', // [TH-review]
      chart_records_title: 'ใบแจ้งหนี้ค่าส่วนกลางต่อเดือน', // [TH-review]
      legend_collected: 'เก็บได้', // [TH-review]
      legend_outstanding: 'ค้างชำระ',
      legend_paid: 'ชำระแล้ว',
      legend_partial: 'ชำระบางส่วน', // [TH-review]
      legend_overdue: 'เกินกำหนด', // [TH-review]
      detail_money_title: 'ตามอาคาร / ห้อง', // [TH-review]
      detail_records_title: 'ใบแจ้งหนี้ค่าส่วนกลาง', // [TH-review]
      col_property: 'อาคาร / ห้อง', // [TH-review]
      col_billed: 'เรียกเก็บ', // [TH-review]
      col_collected: 'รับชำระ',
      col_outstanding: 'ค้างชำระ',
      col_rate: 'อัตรา',
      rec_col_invoice: 'เลขที่ใบแจ้งหนี้', // [TH-review]
      rec_col_owner: 'เจ้าของ',
      rec_col_paid: 'ชำระแล้ว',
      rec_col_paid_date: 'วันที่ชำระ', // [TH-review]
      rec_col_status: 'สถานะ',
      status_paid: 'ชำระแล้ว',
      status_partial: 'ชำระบางส่วน', // [TH-review]
      status_overdue: 'เกินกำหนด', // [TH-review]
      no_rows: 'ไม่มีการเรียกเก็บค่าส่วนกลางในช่วงนี้', // [TH-review]
      costs_section_title: 'ค่าใช้จ่ายของอาคารที่เกี่ยวข้องกับค่าส่วนกลาง', // [TH-review]
      costs_section_caption: 'ต้นทุนดำเนินงานระดับอาคาร ไม่ใช่รายได้ค่าส่วนกลางที่เรียกเก็บจากเจ้าของร่วม', // [TH-review]
      costs_total_label: 'ค่าใช้จ่ายรวมในช่วงนี้', // [TH-review]
      costs_col_category: 'หมวดหมู่', // [TH-review]
      costs_col_property: 'อสังหาริมทรัพย์', // [TH-review]
      costs_col_total: 'รวม', // [TH-review]
      cost_category_label: '{{category}} (ค่าใช้จ่าย)', // [TH-review]
      costs_empty: 'ไม่มีค่าใช้จ่ายของอาคารในช่วงนี้', // [TH-review]
    },
    bank_recon: {
      title: 'กระทบยอดธนาคาร',
      subtitle: 'รายการที่กระทบยอดแล้วเทียบกับยังไม่กระทบ', // [TH-review]
      filters_label: 'ตัวกรอง',
      filter_bank: 'ธนาคาร',
      kpi_matched: 'กระทบยอดแล้ว', // [TH-review]
      kpi_unmatched: 'ยังไม่กระทบยอด', // [TH-review]
      kpi_match_rate: 'อัตราการกระทบยอด', // [TH-review]
      kpi_unmatched_amount: 'ยอดที่ยังไม่จับคู่', // [TH-review]
      chart_section_title: 'ธุรกรรมต่อเดือน', // [TH-review]
      legend_matched: 'จับคู่แล้ว', // [TH-review]
      legend_unmatched: 'ยังไม่จับคู่', // [TH-review]
      legend_needs_review: 'ต้องตรวจสอบ', // [TH-review]
      detail_section_title: 'รายละเอียดธุรกรรม', // [TH-review]
      detail_link_hint: 'รายการ การจับคู่ และการส่งออกอยู่ในหน้ากระทบยอด', // [TH-review]
      open_reconciliation: 'เปิดหน้ากระทบยอดธนาคาร', // [TH-review]
      unmatched_need_attention: '{{count}} รายการยังไม่จับคู่ที่ต้องดำเนินการ', // [TH-review]
      bank_all: 'ทุกธนาคาร', // [TH-review]
      bank_scb: 'SCB',
      bank_kbank: 'KBank',
      bank_bbl: 'BBL',
    },
    financial_statements: {
      title: 'งบการเงิน',
      subtitle: 'งบกำไรขาดทุนและงบดุล', // [TH-review]
      print: 'พิมพ์', // [TH-review]
      export_csv: 'ส่งออก CSV',
      filters_label: 'ตัวกรอง (งบกำไรขาดทุน)',
      filters_scope_note: 'ช่วงวันที่ใช้กับงบกำไรขาดทุนเท่านั้น งบดุลแสดงยอด ณ วันนี้',
      filter_property: 'อสังหาริมทรัพย์',
      period_label: 'ช่วงเวลา', // [TH-review]
      pl_period_range: 'ช่วงเวลา: {{from}} – {{to}}',
      bs_as_of_date: 'ณ วันที่ {{date}}',
      pl_section_title: 'งบกำไรขาดทุน', // [TH-review]
      bs_section_title: 'งบดุล', // [TH-review]
      revenue: 'รายได้', // [TH-review]
      expenses: 'ค่าใช้จ่าย',
      net_income: 'กำไรสุทธิ', // [TH-review]
      assets: 'สินทรัพย์', // [TH-review]
      liabilities: 'หนี้สิน',
      equity: 'ส่วนของเจ้าของ', // [TH-review]
      total_revenue: 'รายได้รวม', // [TH-review]
      total_expenses: 'ค่าใช้จ่ายรวม',
      total_assets: 'สินทรัพย์รวม', // [TH-review]
      total_liab_equity: 'หนี้สิน + ส่วนของเจ้าของ', // [TH-review]
      derived_note: 'คำนวณจากใบแจ้งหนี้และค่าใช้จ่าย (ไม่มีรายการบัญชีที่บันทึกในช่วงนี้)', // [TH-review]
      no_data: 'ไม่มีรายการบัญชีที่บันทึกในช่วงนี้', // [TH-review]
      lines: {
        invoiced_revenue: 'รายได้จากการวางบิล', // [TH-review]
        recorded_expenses: 'ค่าใช้จ่ายที่บันทึก', // [TH-review]
        retained_earnings: 'กำไรสะสม',
        current_year_earnings: 'กำไรปีปัจจุบัน',
      },
    },
  },
}
